import axios from 'axios'

export default {
    namespaced: true,
    state: {
        year: {},
    },
    mutations: {
        SET_YEAR(state, payload) {
            state.year = payload;
        },
    },
    actions: {
        FetchYearByAcademicSession({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/years/fetch/academic-session`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_YEAR', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchYearByAcademicSession: ${error.response.data || error.message}`));
            });
        },
    },
    getters: {
        Year(state) { return state.year; },
    }
}
